import { render, staticRenderFns } from "./UsersPrivilegeReport.vue?vue&type=template&id=a4400058&scoped=true&"
import script from "./UsersPrivilegeReport.vue?vue&type=script&lang=js&"
export * from "./UsersPrivilegeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4400058",
  null
  
)

export default component.exports